<template>
  <div>
    <div>
      <img
        class="mainBackImg"
        :src="
          language === 'zh'
            ? require('@/assets/images/newsInformation/backgroundImg.jpg')
            : require('@/assets/images/newsInformation/en_backgroundImg.jpg')
        "
      />
    </div>
    <div class="bread">
      <el-row :gutter="0" type="flex" justify="center">
        <el-col :xs="24" :sm="21" :md="20" :lg="18" :xl="16">
          <slot name="breadcrumb"></slot>
        </el-col>
      </el-row>
    </div>
    <div class="container">
      <el-row :gutter="0" type="flex" justify="center">
        <el-col :xs="24" :sm="21" :md="18">
          <!-- 公司新闻 -->
          <div>
            <div class="nav">
              <div class="boxTitle">{{ $t("news.companyNews") }}</div>
              <div class="more" @click="goMoreNewsPage('/news_list', 3000)">
                <span>{{ $t("news.allNews") }}</span>
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
            <el-divider></el-divider>
            <div v-if="newsData.length > 0" class="news">
              <div class="left-card" @click="goDetailPage(newsData[0].id)">
                <div
                  class="backImg"
                  :style="{ backgroundImage: 'url(' + newsData[0].pic + ')' }"
                >
                  <div class="content">
                    <div class="content-title">{{ newsData[0].title }}</div>
                    <div class="content-time">
                      {{ newsData[0].publish_time }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="right-card">
                <template v-for="(item, index) in newsData">
                  <div
                    v-if="index > 0"
                    :key="index"
                    class="flexCard"
                    @click="goDetailPage(item.id)"
                  >
                    <img class="itemImg" :src="item.pic" />
                    <div class="itemContent">
                      <div class="itemTitle">{{ item.title }}</div>
                      <div class="itemDate">{{ item.publish_time }}</div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <!-- 行业动态 -->
          <div hidden >
            <div class="nav">
              <div class="boxTitle">{{ $t("news.industryNews") }}</div>
              <div class="more" @click="goMoreNewsPage('/news_list', 3001)">
                <span>{{ $t("news.allIndustryNews") }}</span>
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
            <el-divider></el-divider>
            <div style="margin-top: -20px">
              <industryTrends res="industryTrends" :type="3" />
            </div>
          </div>
          <!-- 信息公开 -->
          <div class="info" hidden>
            <div class="nav">
              <div class="boxTitle">{{ $t("news.informationDisclosure") }}</div>
              <div class="more" @click="goMoreNewsPage('/news_list', 3014)">
                <span>{{ $t("news.allIndustryNews") }}</span>
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
            <el-divider></el-divider>
            <div v-if="publicInfoData.length > 0" class="info-card">
              <div
                class="info-left-card"
                @click="goDetailPage(publicInfoData[0].id)"
              >
                <div
                  class="infoBackImg"
                  :style="{
                    backgroundImage: 'url(' + publicInfoData[0].pic + ')',
                  }"
                >
                  <div class="infoContent">
                    <div class="infoContent-title">
                      {{ publicInfoData[0].title }}
                    </div>
                    <div class="infoContent-time">
                      {{ publicInfoData[0].publish_time }}
                    </div>
                  </div>
                </div>
              </div>
              <template v-for="(item, index) in publicInfoData">
                <div
                  v-if="index > 0"
                  :key="index"
                  class="info-right-card"
                  @click="goDetailPage(item.id)"
                >
                  <img class="info-itemImg" :src="item.pic" />
                  <div class="itemTitle" style="margin-top: 10px">
                    {{ item.title }}
                  </div>
                  <div class="itemDate" style="margin-top: 10px">
                    {{ item.publish_time }}
                  </div>
                </div>
              </template>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import industryTrends from "./newsItem/industryTrends.vue";
import { getIndex } from "@/api/acticle/acticle";
import { parseTime } from "@/utils/index";
export default {
  components: { industryTrends },
  data() {
    return {
      language: localStorage.getItem("language") || "zh",
      newsData: [],
      newsRightData: [],
      publicInfoData: [],
      publicInfoRightData: [],
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      this.getData(3000, 4, "newsData");
      this.getData(3014, 3, "publicInfoData");
    },
    getData(id, size, listName) {
      const pade = { id, page: 1, size };
      getIndex(pade).then((res) => {
        res.data.data.forEach((item) => {
          item.publish_time = parseTime(
            item.publish_time,
            +id === 3000 && localStorage.getItem("language") === "zh"
              ? "{y}年{m}月{d}日"
              : "{y}-{m}-{d}"
          );
        });
        this[listName] = res.data.data;
      });
    },
    // 查看新闻信息
    goMoreNewsPage(path, id) {
      this.$router.push({ path, query: { id } });
    },
    // 详情
    goDetailPage(id) {
      this.$router.push({ path: "/newsDetail", query: { id: id } });
    },
  },
};
</script>

<style scoped>
.bread {
  background-color: #f6f6f6;
  padding: 15px 20px;
}
.mainBackImg {
  width: 100%;
  /* height: 300px; */
}
.container {
  padding: 20px;
  background: url("../../assets/images/home/lunbobg.jpg") top center no-repeat;
  background-size: 100% auto;
}
.nav {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}
.boxTitle {
  font-size: 22px;
  font-weight: 800;
  color: #015a9c;
  letter-spacing: 2px;
}
.more {
  font-size: 14px;
  color: #787b8a;
  cursor: pointer;
}
.more > span {
  margin-right: 7px;
}
.news {
  display: flex;
  margin-bottom: 25px;
}
.left-card {
  width: 60%;
  height: 55vh;
}
.backImg {
  width: 100%;
  /* height: 410px; */
  height: 100%;
  background-image: url("../../assets/images/productCenter/1.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  cursor: pointer;
  border-radius: 10px;
}
.content {
  display: flex;
  justify-content: space-between;
  padding: 15px;
  background-color: rgba(0, 0, 0, 0.25);
  border-radius: 10px 10px 0 0;
}
.content-title {
  width: 65%;
  font-size: 18px;
}
.content-time {
  width: 35%;
  text-align: right;
  font-size: 18px;
}
.backImg > div {
  color: #ffffff;
  font-size: 15px;
}
.right-card {
  width: 45%;
  margin-left: 2%;
}
.flexCard {
  display: flex;
  margin-bottom: 15px;
}
.itemImg {
  margin-right: 20px;
  /* width: 100px; */
  width: 45%;
  /* height: 123px; */
  height: calc((55vh - 30px) / 3);
  cursor: pointer;
  border-radius: 10px;
}
.itemContent {
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.itemTitle {
  font-size: 15px;
}
.itemDate {
  font-size: 13px;
  color: #787b8a;
}
.info {
  margin-top: 25px;
}
.info-card {
  display: flex;
  /* justify-content: space-around; */
}
.info-left-card {
  width: 40%;
}
.infoBackImg {
  /* width: 95%; */
  height: 300px;
  background-image: url("../../assets/images/productCenter/1.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  cursor: pointer;
  border-radius: 10px;
  position: relative;
}
.infoContent {
  display: flex;
  /* justify-content: space-between; */
  padding: 10px;
  background-color: rgba(255, 255, 255, 0.55);
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}
.infoContent-title {
  width: 65%;
  font-weight: 800;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.infoContent-time {
  width: 35%;
  text-align: right;
}
.info-right-card {
  width: 28%;
  margin-left: 2%;
}
.info-itemImg {
  width: 100%;
  height: 200px;
  cursor: pointer;
  border-radius: 10px;
}
@media only screen and (max-width: 992px) {
  .boxTitle {
    font-size: 18px;
  }
  .news {
    display: block;
  }
  .left-card {
    width: 100%;
    height: auto;
  }
  .backImg {
    height: 45vw;
    margin-bottom: 15px;
  }
  .content {
    padding: 10px;
  }
  .content > div {
    font-size: 14px;
  }
  .right-card {
    width: 100%;
    margin-left: 0;
  }
  .itemImg {
    height: 25vw;
  }
  .info-card {
    display: block;
  }
  .info-left-card {
    width: 100%;
    margin-right: 0;
  }
  .infoBackImg {
    height: 40vw;
  }
  .info-itemImg {
    width: 100%;
    height: 40vw;
    margin-top: 20px;
  }
  .info-right-card {
    width: 100%;
    margin-left: 0;
  }
}
</style>